// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"OrderListLoadMoreButton-8df1fb11abf3b49b","card":"OrderListLoadMoreButton-c637d815cac7e71f"};